<template>
  <div class="ui-center bloco-contrato" id="bloco">
    <h1 v-if="activePhase == 1" class="ui-title f-32 contrato_title">
      Vamos iniciar seu contrato!
    </h1>
    <div class="container" v-if="activePhase == 1">
      <div class="row">
        <div class="spacer-contrato mt-3">Dados do Registro</div>
        <div class="col-12 col-lg-6">
          <div>
            <h4 class="ui-paragraph f-20 contrato_frase mb-lg-3 mt-lg-4"
              :class="checkErroFonte('contractor_n_register')">
              Número do CR / Número do registro Sinarm
              <i v-tooltip="{
      content:
        'Se for CAC nos informe o <b>Número de CR</b>, se for PF nos informe o <b>Número de Registro</b> que está na primeira página do seu CRAF',
      html: true,
      theme: 'tooltip',
    }" class="fa fa-question-circle info-label" aria-hidden="true"></i>
            </h4>
            <div :class="checkErroCampo('contractor_n_register')" class="bloco-input">
              <input class="ui-input login-input" type="text" ref="contractor_n_register" name="contractor_n_register"
                maxlenght="20" v-model="form.contractor_n_register" />
            </div>
          </div>
          <div>
            <h4 class="ui-paragraph f-20 contrato_frase mb-lg-3" :class="checkErroFonte('contractor_d_register')">
              Data de
              <span class="bold">vencimento</span> do CR ou registro Sinarm
            </h4>
            <div class="bloco-input" :class="checkErroCampo('contractor_d_register')">
              <the-mask class="ui-input login-input" type="text" :masked="true" v-model="form.contractor_d_register"
                name="contractor_d_register" placeholder="__/__/____" :mask="['##/##/####']"
                :disabled="btnAvancar.disabled" required></the-mask>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <h4 class="ui-paragraph f-20 contrato_frase mb-3 mt-lg-4" :class="checkErroFonte('contractor_t_register')">
            Como sua arma de fogo está <span class="bold">registrada</span>?
          </h4>
          <div class="bloco-checkbox" :class="checkErroCampo('contractor_t_register')">
            <input class="ui-checkbox" type="radio" name="contractor_t_register" @click="radios(1)" />
            <label class="ui-paragraph f-20">Posse/SINARM</label>
          </div>
          <div class="bloco-checkbox" :class="checkErroCampo('contractor_t_register')">
            <input class="ui-checkbox" type="radio" name="contractor_t_register" @click="radios(3)" />
            <label class="ui-paragraph f-20">CR/SIGMA</label>
          </div>
          <div class="bloco-checkbox" :class="checkErroCampo('contractor_t_register')">
            <input class="ui-checkbox" type="radio" name="contractor_t_register" @click="radios(2)" />
            <label class="ui-paragraph f-20">Porte</label>
          </div>
        </div>
        <div v-if="client.state === ''" class="spacer-contrato mt-3">Endereço do Titular</div>
        <div v-if="client.state === ''" class="col-12 col-lg-6">

          <h4 class="ui-paragraph f-20 contrato_frase nascimento mb-lg-3 mt-lg-4" :class="checkErroFonte('state')">
            Informe seu <span class="bold">estado</span>
          </h4>
          <div class="bloco-input" :class="checkErroCampo('state')">
            <select class="ui-input login-input" ref="state" required v-model="model_state" id="state" name="state"
              @keyup.enter.prevent="disableEnter">
              <option v-for="(option, index) in select_state" :key="index" :value="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
        <div v-if="client.state === ''" class="col-12 col-lg-6">
          <h4 class="ui-paragraph f-20 contrato_frase nascimento mb-lg-3 mt-lg-4" :class="checkErroFonte('city')">
            Informe sua <span class="bold">cidade</span>
          </h4>

          <div class="bloco-input" :class="checkErroCampo('city')">
            <select class="ui-input login-input" ref="city" required v-model="model_city" id="city" name="city">
              <option v-if="model_state === ''" disabled selected>Selecione um estado primeiro</option>
              <option v-else v-for="(option, index) in select_cities" :key="index" :value="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="spacer-contrato mt-3">Dados do Equipamento</div>
        <div class="col-12 col-lg-6">
          <!-- <div>
            <h4 class="
                ui-paragraph
                f-20
                contrato_frase
                nascimento
                mb-lg-3
                mt-lg-4
              " :class="checkErroFonte('tipo')">
              Selecione a <span class="bold">categoria</span>
            </h4>
            <div class="bloco-input" :class="checkErroCampo('tipo')">
              <i class="fa fa-chevron-down select-fa" aria-hidden="true"></i>
              <select class="ui-input login-input" required ref="tipo" v-model="form.tipo" name="tipo">
                <option value="" selected disabled>
                  Selecione uma categoria
                </option>
                <option v-for="category in JSON.parse(categories)" :key="category.value" :value="category.value">
                  {{ category.label }}
                </option>
              </select>
            </div>
          </div> -->
          <div>
            <h4 class="ui-paragraph f-20 contrato_frase nascimento mb-lg-3 mt-lg-4" :class="checkErroFonte('marca')">
              Informe a <span class="bold">marca</span>
            </h4>
            <div class="bloco-input" :class="checkErroCampo('marca')">
              <input class="ui-input login-input" type="text" ref="marca" name="marca" v-model="form.marca" />
              <!-- <i class="fa fa-chevron-down select-fa" aria-hidden="true"></i>
              <select class="ui-input login-input" ref="marca" required v-model="form.marca" name="marca">
                <option v-if="form.tipo == ''" value="" selected disabled>
                  Selecione uma categoria primeiro
                </option>
                <option v-else value="" selected disabled>
                  Selecione uma marca
                </option>
                <option v-for="brand in brandFilter()" :key="brand.value" :value="brand.value">
                  {{ brand.label }}
                </option>
              </select> -->
            </div>
          </div>
          <div>
            <h4 class="ui-paragraph f-20 cadastro_frase nascimento mb-lg-3" :class="checkErroFonte('equipment_model')">
              Informe o <span class="bold">modelo</span>
            </h4>
            <div class="bloco-input" :class="checkErroCampo('equipment_model')">
              <input class="ui-input login-input" type="text" ref="equipment_model" name="equipment_model"
                v-model="form.equipment_model" />
              <!-- <i class="fa fa-chevron-down select-fa" aria-hidden="true"></i>
              <select class="ui-input login-input" required ref="modelo" v-model="form.equipment_id" name="modelo"
                v-on:change="getValueEquip()">
                <option v-if="form.marca == ''" value="" selected disabled>
                  Selecione uma marca primeiro
                </option>
                <option v-else value="" selected disabled>
                  Selecione um modelo
                </option>
                <option v-for="equip in equipmentFilter()" :key="equip.value" :value="equip.value">
                  {{ equip.label }}
                </option>
                <option v-if="form.marca !== ''" value="outro_modelo">
                  OUTROS
                </option>
              </select> -->
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div>
            <h4 class="ui-paragraph f-20 cadastro_frase nascimento mb-lg-3 mt-lg-4"
              :class="checkErroFonte('equipment_value')">
              Informe o <span class="bold">valor</span> do seu equipamento
            </h4>
            <div class="bloco-input" :class="checkErroCampo('equipment_value')">
              <money class="ui-input login-input" type="text" ref="equipment_value" name="equipment_value"
                v-model="form.equipment_value" v-bind="money"></money>
              <!-- <p class="alterar_valor">
                Caso o valor da sua arma não seja o apresentado, pode alterar o
                valor qual foi pago
              </p> -->
            </div>
          </div>
          <!-- <div>
            <h4 class="
                ui-paragraph
                f-20
                cadastro_frase
                nascimento
                mb-lg-3
                mt-lg-4
              " :class="checkErroFonte('weapon_caliber')">
              Informe o <span class="bold">calibre</span>
            </h4>
            <div class="bloco-input" :class="checkErroCampo('weapon_caliber')">
              <input class="ui-input login-input" type="text" ref="weapon_caliber" name="weapon_caliber" maxlenght="10"
                v-model="form.weapon_caliber" />
            </div>
          </div> -->
          <!-- <div v-if="form.equipment_id == 'outro_modelo'">
            <h4 class="ui-paragraph f-20 cadastro_frase nascimento mb-lg-3" :class="checkErroFonte('equipment_model')">
              Descreva o <span class="bold">modelo</span> da sua arma
            </h4>
            <div class="bloco-input" :class="checkErroCampo('equipment_model')">
              <input class="ui-input login-input" type="text" ref="equipment_model" name="equipment_model"
                maxlenght="150" v-model="form.equipment_model" />
            </div>
          </div>
          <div>
            <h4 class="ui-paragraph f-20 cadastro_frase nascimento mb-lg-3" :class="checkErroFonte('weapon_serial')">
              Insira o <span class="bold">Número de série</span> da sua arma
            </h4>
            <div class="bloco-input" :class="checkErroCampo('weapon_serial')">
              <input class="ui-input login-input" type="text" ref="weapon_serial" name="weapon_serial" maxlenght="20"
                v-model="form.weapon_serial" />
            </div>
          </div> -->

          <!-- <div>
            <h4
              class="ui-paragraph f-20 cadastro_frase nascimento mb-lg-3"
              :class="checkErroFonte('weapon_n_nf')"
            >
              Insira o <span class="bold">Número da Nota Fiscal</span> da sua
              arma
            </h4>
            <div class="bloco-input" :class="checkErroCampo('weapon_n_nf')">
              <input
                class="ui-input login-input"
                type="number"
                ref="weapon_n_nf"
                name="weapon_n_nf"
                maxlenght="20"
                v-model="form.weapon_n_nf"
              />
              <p class="alterar_valor">
                Caso não possua, sem problemas! Este campo não é obrigatório
              </p>
            </div>
          </div> -->
        </div>
        <div class="col-12 row">
          <div v-for="item in texto_invalido" :key="item" class="col-6 d-flex">
            <i class="fa fa-times ui-invalid-font mr-2" aria-hidden="true"></i>
            <p class="ui-invalid-font">{{ item }}</p>
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center flex-column">
          <button class="ui-button-yellow login-button" type="button" @click.prevent="checkForm()"
            :disabled="btnAvancar.disabled" v-html="btnAvancar.text"></button>
          <a href="/" class="
            ui-paragraph
            f-20
            voltar
            align-items-center
            d-flex
            justify-content-center
            voltar_pagamentos
          ">
            Voltar para a Home
          </a>
        </div>
      </div>
    </div>

    <h1 v-if="activePhase == 2" class="ui-title ui-center f-32 contrato_title">
      Escolha seu plano!
    </h1>
    <div class="container" v-if="activePhase == 2">
      <div class="row">
        <div class="col-12 col-lg-6 d-flex justify-content-center">
          <div @click="form.plan = 1" class="bloco-plano-contrato" :class="form.plan == 1 ? 'plano-ativo' : ''">
            <div class="planos">
              <p :class="form.plan == 1 ? 'ativo-plano' : ''">{{ JSON.parse(config).name_open_plan }}</p>
            </div>
            <div class="open">
              <div class="descricao ui-paragraph f-20 ul_pag" v-html="JSON.parse(config).description_open_plan"></div>
              <div class="preço">
                <p>Por apenas:</p>

                <div class="d-flex justify-content-center">
                  <div class="ui-button-yellow login-button button-plano valor" type="button">
                    {{
      new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(
        getEquipmentValue() *
        (JSON.parse(config).price_open_plan / 100)
      )
    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 d-flex justify-content-center">
          <div @click="form.plan = 0" class="bloco-plano-contrato" :class="form.plan == 0 ? 'plano-ativo' : ''">
            <div class="planos">
              <p :class="form.plan == 0 ? 'ativo-plano' : ''">{{ JSON.parse(config).name_pro_plan }}</p>
            </div>
            <div class="pro">
              <div class="descricao ui-paragraph f-20 ul_pag" v-html="JSON.parse(config).description_pro_plan"></div>
              <div class="preço">
                <p>Por apenas:</p>
                <div class="d-flex justify-content-center">
                  <div class="ui-button-yellow login-button button-plano valor" type="button">
                    {{
      new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(
        getEquipmentValue() *
        (JSON.parse(config).percentage_pro_plan / 100)
      )
    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 d-flex align-items-center flex-column">
          <div class="bloco-checkbox" :class="erroClausula">
            <input class="ui-checkbox" type="checkbox" v-model="aceito_clausula" />
            <label class="ui-paragraph f-20">Li e aceito as <a href="/clausulas" target="_blank"
                rel="noopener noreferrer">Cláusulas do Contrato</a></label>
          </div>
          <p v-show="erroClausula != ''" class="ui-invalid-font">Você precisa aceitar as Cláusulas do Contrato</p>
        </div>
        <div class="d-flex justify-content-center">
          <button @click="checkClausulas()" class="ui-button-yellow login-button" type="button">
            Selecionar pagamento
          </button>
        </div>
        <h4 class="
            ui-paragraph
            f-20
            voltar
            align-items-center
            d-flex
            justify-content-center
            voltar_pagamentos
          " @click="activePhase = 1">
          Voltar
        </h4>
      </div>
    </div>

    <h1 v-if="activePhase == 3" class="ui-title ui-center w-100 f-32 contrato_title">
      Escolha a forma de pagamento!
    </h1>
    <div class="container ui-center" v-if="activePhase == 3">
      <div class="bloco-plano-contrato pagamento">
        <div class="icons_pagamento">
          <div class="bloco_icon ativo_pag" @click.prevent="
      selectPayment('credito', 0),
      (texto_pag_invalido = []),
      (pagamento_invalido = [])
      " id="0" style="cursor: pointer">
            <i class="fa fa-credit-card-alt" aria-hidden="true"></i>
            <p>Crédito</p>
          </div>
          <!-- <div class="bloco_icon" id="2" @click.prevent="
      selectPayment('boleto', 2),
      (texto_pag_invalido = []),
      (pagamento_invalido = [])
      " style="cursor: pointer">
            <i class="fa fa-file-text-o" aria-hidden="true"></i>
            <p>Boleto</p>
          </div> -->
          <div class="bloco_icon" id="3" @click.prevent="
      selectPayment('pix', 3),
      (texto_pag_invalido = []),
      (pagamento_invalido = [])
      " style="cursor: pointer">
            <i class="fa fa-usd" aria-hidden="true"></i>
            <p>PIX</p>
          </div>
        </div>
        <div class="valor-plano-pag">
          <div class="pro" v-if="form.plan == 0">
            <p>
              Valor do pagamento:
              <span>
                {{
      new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(
        getEquipmentValue() *
        (JSON.parse(config).percentage_pro_plan / 100)
      )
    }}</span>
            </p>
          </div>
          <div class="pro" v-if="form.plan == 1">
            <p>
              Valor do pagamento:
              <span>
                {{
      new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(
        getEquipmentValue() *
        (JSON.parse(config).price_open_plan / 100)
      )
    }}</span>
            </p>
          </div>
        </div>
        <div class="bloco-pagamento credito" id="credito" v-if="activePhasePag === 'credito'">
          <div class="bloco-input bloco-input-p" :class="checkErroPagamento('number')">
            <label class="ui-label f-20">Número do cartão</label>
            <the-mask class="ui-input input_pagamento password" type="text" ref="number_credit" name="number_credit"
              v-model="form.credit.number" :mask="['#### #### #### ####']" :masked="true" required></the-mask>
          </div>
          <div class="bloco-input bloco-input-p" :class="checkErroPagamento('cvc')">
            <label class="ui-label f-20">CVC</label>
            <the-mask class="ui-input input_pagamento password" type="text" name="cvc_credit" v-model="form.credit.cvc"
              :mask="['###']" :masked="true" required></the-mask>
          </div>
          <div class="bloco-input bloco-input-p" :class="checkErroPagamento('validity')">
            <label class="ui-label f-20">Data de validade</label>
            <the-mask class="ui-input input_pagamento password" type="text" name="validity_credit"
              v-model="form.credit.validity" :mask="['##/####']" :masked="true" required></the-mask>
          </div>
          <div class="bloco-input bloco-input-p" :class="checkErroPagamento('name')">
            <label class="ui-label f-20">Nome impresso</label>
            <input class="ui-input input_pagamento password" type="text" name="name_credit" maxlenght="40"
              v-model="form.credit.name" required />
          </div>
          <div class="bloco-input bloco-input-p" :class="checkErroPagamento('installments')">
            <label class="ui-label f-20">Parcelas</label>
            <i class="fa fa-chevron-down select-fa" aria-hidden="true"></i>
            <select class="ui-input input_pagamento password parcelas" name="installments_credit"
              v-model="form.credit.installments" required>
              <option v-for="(item, index) in getParcels()" :key="index" :value="item.value">
                {{ item.label }}
              </option>
            </select>
          </div>
          <div v-for="item in texto_pag_invalido" :key="item" class="col-12 d-flex">
            <i class="fa fa-times ui-invalid-font mr-2" aria-hidden="true"></i>
            <p class="ui-invalid-font">{{ item }}</p>
          </div>
          <button class="ui-button-green button_pagamento" type="button" @click.prevent="checkPayment()"
            :disabled="btnSubmit.disabled" v-html="btnCredit"></button>
        </div>

        <div class="bloco-pagamento boleto" id="boleto" v-if="activePhasePag === 'boleto'">
          <ul class="ul_pag">
            <li class="ui-paragraph f-20">
              Depois de gerar o boleto, você será encaminhado a uma tela para
              baixar o boleto.
            </li>
          </ul>
          <div class="bloco-input bloco-input-p cpf" :class="checkErroPagamento('cpf')">
            <label class="ui-label f-20">CPF</label>
            <the-mask class="ui-input input_pagamento password" type="text" ref="cpf_ticket" name="cpf_ticket"
              v-model="form.bank_slip.cpf" :mask="['###.###.###-##']" :masked="true" required></the-mask>
          </div>
          <div v-for="item in texto_pag_invalido" :key="item" class="col-12 d-flex">
            <i class="fa fa-times ui-invalid-font mr-2" aria-hidden="true"></i>
            <p class="ui-invalid-font">{{ item }}</p>
          </div>
          <button class="ui-button-green button_pagamento" type="button" @click.prevent="checkPayment()"
            :disabled="btnSubmit.disabled" v-html="btnBol"></button>
        </div>

        <div class="bloco-pagamento pix" id="pix" v-if="activePhasePag === 'pix'">
          <ul class="ul_pag">
            <li class="ui-paragraph f-20">
              O pix é válido até a
              <span>meia noite de hoje</span>.
            </li>
          </ul>
          <div class="bloco-input bloco-input-p cpf" :class="checkErroPagamento('cpf')">
            <label class="ui-label f-20">CPF</label>
            <the-mask class="ui-input input_pagamento password" type="text" name="cpf_pix" ref="cpf_pix"
              v-model="form.pix.cpf" :mask="['###.###.###-##']" :masked="true" required></the-mask>
          </div>
          <div v-for="item in texto_pag_invalido" :key="item" class="col-12 d-flex">
            <i class="fa fa-times ui-invalid-font mr-2" aria-hidden="true"></i>
            <p class="ui-invalid-font">{{ item }}</p>
          </div>
          <button class="ui-button-green button_pagamento" type="button" @click.prevent="checkPayment()"
            :disabled="btnSubmit.disabled" v-html="btnPix"></button>
        </div>
        <h4 class="
            ui-paragraph
            f-20
            voltar
            align-items-center
            d-flex
            justify-content-center
            voltar_pagamentos
          " @click="activePhase = 2">
          Voltar
        </h4>
      </div>
    </div>

    <div class="bloco" v-if="activePhase == 4">
      <div class="bloco-plano-contrato ui-center" style="flex-direction: column">
        <h4 class="ui-paragraph-yellow f-20" style="margin-bottom: 10px">
          Código do boleto:
        </h4>
        <ul>
          <li class="ui-paragraph text-center f-20">
            Após realizar o pagamento, clique em avançar
          </li>
        </ul>
        <p class="ui-paragraph f-20 text-center" style="word-break: break-all">
          {{ form.bank_slip.code }}
        </p>
        <a :href="form.bank_slip.download_link" target="_blank">
          <button class="ui-button-green login-button button_confirmacao pag_boleto" type="button">
            Baixar boleto
          </button>
        </a>
        <button class="ui-button-yellow login-button button_confirmacao pag_boleto" type="button"
          @click.prevent="activePhase = 6">
          Avançar
        </button>
      </div>
    </div>

    <div class="bloco" v-if="activePhase == 5">
      <div class="bloco-plano-contrato ui-center" style="flex-direction: column">
        <h4 class="ui-paragraph-yellow f-20" style="margin-bottom: 10px">
          Código PIX:
        </h4>
        <ul>
          <li class="ui-paragraph text-center f-20">
            Após realizar o pagamento, clique em avançar
          </li>
        </ul>
        <img v-bind:src="'data:image/jpeg;base64,' + form.pix.code" class="qr_code" />
        <button class="ui-button-yellow login-button button_confirmacao" type="button" @click.prevent="activePhase = 6">
          Avançar
        </button>
      </div>
    </div>

    <div class="bloco" v-if="activePhase == 6">
      <div class="ui-center" style="flex-direction: column">
        <img src="img/front/check.gif" class="pagamento_img" />
        <img src="img/front/dark_check.gif" class="pagamento_img_dark" />
        <h4 class="ui-title f-32 contrato_title pagamento_title text-center">
          Parabéns, seu contrato foi gerado e será analisado pelo time da
          ARMEIROSEG!
        </h4>
        <a href="/">
          <button class="
              ui-button-green
              f-20
              voltar-pag
              align-items-center
              d-flex
              justify-content-center
              voltar_pagamentos
            ">
            Voltar para a Home
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import brazil from "/public/cities/cidades.json";
import { VMoney } from "v-money";
export default {
  props: ["img", "equipments", "brands", "categories", "config", "client", "city", "state"],
  components: {
    DatePicker,
    VMoney,
  },
  data() {
    return {
      activePhase: 1,
      // activePhase: 2,
      activePhasePag: "credito",
      randon: "",
      btnAvancar: {
        text: "Escolher plano",
        disabled: false,
      },
      form: {
        contractor_n_register: "",
        contractor_d_register: "",
        contractor_t_register: "",
        // tipo: "",
        marca: "",
        equipment_model: "",
        equipment_id: "outro_modelo",
        // weapon_caliber: "",
        // weapon_serial: "",
        equipment_value: "",
        // equipment_value: "R$ 16.500,00",
        plan: 1,
        payment_method: 0,
        credit: {
          number: "",
          cvc: "",
          validity: "",
          name: "",
          installments: "",
        },
        bank_slip: {
          code: "",
          download_link: "",
          cpf: "",
        },
        pix: {
          cpf: "",
          code: "",
        },
      },
      aceito_clausula: false,
      erroClausula: '',
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: true,
      },
      bloco_invalido: [],
      texto_invalido: [],
      pagamento_invalido: [],
      texto_pag_invalido: [],
      btnSubmit: {
        disabled: false,
      },
      btnPix: "Gerar QRCode",
      btnCredit: "Realizar pagamento",
      btnBol: "Gerar boleto",
      errors: {},
      validateErrors: "",
      select_cities: [],
      select_state: [],
      model_state: "",
      model_city: "",
    };
  },
  watch: {
    pagamento() {
      this.mudaImg();
      this.mudaImgDark();
    },
    async "form.contractor_d_register"() {
      if (this.form.contractor_d_register.length == 10) {
        var val = await this.validate(this.form.contractor_d_register, 3);
        let val1Req = () => {
          return val;
        };
        if (val1Req() == "") {
          this.bloco_invalido.splice("contractor_d_register", 1);
          this.texto_invalido.splice("Seu registro está vencido", 1);
        } else {
          this.bloco_invalido.push("contractor_d_register");
          this.texto_invalido.push(val1Req());
        }
      }
    },
    model_state() {
      this.select_cities = brazil.estados.filter((estado) => {
        if (estado.sigla == this.model_state) {
          return estado.cidades;
        }
      });
      if (this.select_cities[0]) {
        for (var city of this.select_cities[0].cidades) {
          this.select_cities.push({
            value: city,
            label: city,
          });
        }
      }
    },
  },
  methods: {
    checkForm: function () {
      this.bloco_invalido = [];
      this.texto_invalido.filter((i) => {
        if (i != "Seu registro está vencido") {
          this.texto_invalido.splice(i);
        }
      });
      if (this.client.state === "") {
        if (this.model_state === "") {
          this.texto_invalido.push("Selecione o estado");
          this.bloco_invalido.push("state");
        }
        if (this.model_city === "") {
          this.texto_invalido.push("Selecione uma cidade");
          this.bloco_invalido.push("city");
        }
      }
      var form = this.form;
      Object.keys(form).forEach((key) => {
        let value = form[key];
        if (
          key == "plan" ||
          key == "payment_method" ||
          key == "credit" ||
          key == "bank_slip" ||
          key == "pix" ||
          key == "tipo" ||
          key == "weapon_caliber" ||
          key == "weapon_serial" ||
          key == "equipment_id"
        ) {
          return;
        }
        // if (form.equipment_id !== "outro_modelo" && key == "equipment_model") {
        //   return;
        // }
        if (key == "contractor_d_register" && value.length < 10) {
          this.texto_invalido.push("Insira uma data válida");
          this.bloco_invalido.push(key);
        }
        if (value == "" || value == null || value == "R$ 0,00") {
          this.bloco_invalido.push(key);
          if (
            !this.texto_invalido.includes(
              "Você precisa preencher todos os campos obrigatórios"
            )
          ) {
            this.texto_invalido.push(
              "Você precisa preencher todos os campos obrigatórios"
            );
          }
        }
      });

      if (this.texto_invalido.length < 1 && this.bloco_invalido.length < 1) {
        this.activePhase = 2;
      }
    },
    checkClausulas: function () {
      if (!this.aceito_clausula) {
        this.erroClausula = `ui-invalid-bloco`
      } else {
        this.erroClausula = ``
        this.activePhase = 3
      }
    },
    checkErroCampo: function (campo) {
      var retorno = false;
      this.bloco_invalido.filter((e) => {
        if (e == campo) {
          retorno = true;
        }
      });
      if (retorno == true) {
        return "ui-invalid-bloco";
      } else {
        return ""
      }
    },
    checkErroFonte: function (fonte) {
      var retorno = false;
      this.bloco_invalido.filter((e) => {
        if (e == fonte) {
          retorno = true;
        }
      });
      if (retorno == true) {
        return "ui-invalid-font";
      } else {
        return ""
      }
    },
    checkPayment: function () {
      this.btnSubmit.disabled = true;
      this.btnPix = "<div class='loader'></div>";
      this.btnBol = "<div class='loader'></div>";
      this.btnCredit = "<div class='loader'></div>";
      this.pagamento_invalido = [];
      this.texto_pag_invalido = [];
      if (this.form.payment_method == 0) {
        var card = this.form.credit;
        var camposKeys = Object.keys(card);
        for (let i = 0; i < camposKeys.length; i++) {
          const key = camposKeys[i];
          var campo = card[key];
          if (campo == "" || campo == null || campo == 0) {
            this.pagamento_invalido.push(key);
            if (
              !this.texto_pag_invalido.includes("Estes campos são obrigatórios")
            ) {
              this.texto_pag_invalido.push("Estes campos são obrigatórios");
            }
          }
        }
      } else if (this.form.payment_method == 2) {
        var bank_slip = this.form.bank_slip;
        if (
          bank_slip.cpf == "" ||
          bank_slip.cpf == null ||
          bank_slip.cpf < 14
        ) {
          this.pagamento_invalido.push("cpf");
          if (!this.texto_pag_invalido.includes("Este campo é obrigatório")) {
            this.texto_pag_invalido.push("Este campo é obrigatório");
          }
        }
      } else if (this.form.payment_method == 3) {
        var pix = this.form.pix;
        if (pix.cpf == "" || pix.cpf == null || pix.cpf < 14) {
          this.pagamento_invalido.push("cpf");
          if (!this.texto_pag_invalido.includes("Este campo é obrigatório")) {
            this.texto_pag_invalido.push("Este campo é obrigatório");
          }
        }
      }

      if (
        this.texto_pag_invalido.length < 1 &&
        this.pagamento_invalido.length < 1
      ) {
        this.submitForm();
      } else {
        this.btnSubmit.disabled = false;
        this.btnPix = "Gerar QRCode";
        this.btnBol = "Gerar boleto";
        this.btnCredit = "Realizar pagamento";
      }
    },
    checkErroPagamento(campo) {
      var retorno = false;
      this.pagamento_invalido.filter((e) => {
        console.log(e, campo);
        if (e == campo) {
          retorno = true;
        }
      });
      if (retorno == true) {
        return "ui-invalid-bloco";
      }
    },
    selectPayment: function (step, method) {
      this.form.payment_method = method;
      this.activePhasePag = step;
      this.getParcels();
      switch (method) {
        case 0:
          setTimeout(() => {
            this.$refs.number_credit.$el.focus();
          }, 200);
          break;

        case 2:
          setTimeout(() => {
            this.$refs.cpf_ticket.$el.focus();
          }, 200);
          break;

        case 3:
          setTimeout(() => {
            this.$refs.cpf_pix.$el.focus();
          }, 200);
          break;
      }
      if (
        this.form.payment_method == 0 ||
        this.form.payment_method == 2 ||
        this.form.payment_method == 3
      ) {
        this.bloco_invalido = "";
        this.fonte_invalida = "";
        this.texto_invalido = false;
      }
      var ativo = document.getElementsByClassName("ativo_pag");
      for (let i = 0; i < ativo.length; i++) {
        const element = ativo[i];
        element.classList.remove("ativo_pag");
      }
      document.getElementById(method).classList.add("ativo_pag");
    },
    trocaPaymentClass: function (id) {
      var ativo = document.getElementsByClassName("ativo_pag");
      for (let i = 0; i < ativo.length; i++) {
        const element = ativo[i];
        element.classList.remove("ativo_pag");
      }
      document.getElementById(id).classList.add("ativo_pag");
    },
    getEquipmentValue: function () {
      var arr = this.form.equipment_value.split(" ");
      var value = arr[1];
      value = value.replace(".", "");
      value = value.replace(",", ".");
      return value;
    },
    getParcels: function () {
      var parcels = JSON.parse(this.config).max_parcel;
      var listParcels = [];
      for (let i = 0; i < parcels; i++) {
        var element = {};
        element["value"] = i + 1;
        element["label"] = i + 1 + (i == 0 ? "x Parcela" : "x Parcelas");
        var parcel = "";
        if (this.form.plan == 0) {
          parcel =
            (this.getEquipmentValue() *
              (JSON.parse(this.config).percentage_pro_plan / 100)) /
            (i + 1);
        } else if (this.form.plan == 1) {
          parcel =
            (this.getEquipmentValue() *
              (JSON.parse(this.config).price_open_plan / 100)) /
            (i + 1);
        }
        if (parcel >= 5) {
          listParcels.push(element);
        } else {
          break;
        }
      }
      return listParcels;
    },
    getValueEquip: function () {
      var equipment = JSON.parse(this.equipments).filter(
        (equip) => equip.value == this.form.equipment_id
      );
      if (equipment[0]) {
        this.form.equipment_value = equipment[0].price;
      }
    },
    radios: function (radio) {
      this.form.contractor_t_register = radio;
    },
    equipmentFilter: function () {
      var list = JSON.parse(this.equipments).filter((equip) => {
        if (
          equip.brand == this.form.marca &&
          equip.category == this.form.tipo
        ) {
          return equip;
        }
      });
      return list;
    },
    brandFilter: function () {
      var equipments = JSON.parse(this.equipments).filter(
        (equipment) => equipment.category == this.form.tipo
      );
      var brands = [];
      for (let i = 0; i < equipments.length; i++) {
        const equip = equipments[i];
        var brand = JSON.parse(this.brands).filter(
          (b) => b.value == equip.brand
        );
        brands.push(brand[0]);
      }
      var list = brands.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) => t.value === value.value && t.label === value.label
          )
      );
      return list;
    },
    submitForm: async function () {
      var form = this.form;
      if (this.model_state !== '') {
        form.city = this.model_city
        form.state = this.model_state
      }
      await axios
        .post("/contrato-create", form)
        .then((res) => {
          axios
            .post("/api/cobranca-asaas", res.data)
            .then((response) => {
              if (this.form.payment_method == 0) {
                this.activePhase = 6;
              } else if (this.form.payment_method == 2) {
                this.form.bank_slip.code = response.data.barCode;
                this.form.bank_slip.download_link =
                  response.data.download_link;
                this.activePhase = 4;
              } else if (this.form.payment_method == 3) {
                this.form.pix.code = response.data;
                this.activePhase = 5;
              }
              this.btnSubmit.disabled = false;
              this.btnPix = "Gerar QRCode";
              this.btnBol = "Gerar boleto";
              this.btnCredit = "Realizar pagamento";
            })
            .catch((error) => {
              this.$swal({
                title: error.response.data,
                type: "error",
              });
              this.btnSubmit.disabled = false;
              this.btnPix = "Gerar QRCode";
              this.btnBol = "Gerar boleto";
              this.btnCredit = "Realizar pagamento";
            });
        })
        .catch((e) => {
          if (e.response.data) {
            var errors = e.response.data.errors;
            var errorsKeys = Object.keys(errors);
            for (let i = 0; i < errorsKeys.length; i++) {
              const key = errorsKeys[i];
              this.errors[key] = errors[key];
            }
          }
          this.btnSubmit.disabled = false;
          this.btnPix = "Gerar QRCode";
          this.btnBol = "Gerar boleto";
          this.btnCredit = "Realizar pagamento";
        });
    },
    validate: async function (valor, tipo) {
      this.btnAvancar = {
        text: "<div class='loader'></div>",
        disabled: true,
      };
      var req = await axios
        .post("/api/validate", { valor: valor, tipo: tipo })
        .then((res) => {
          return res.data;
        });
      let returnReq = () => {
        let a = req;
        return a;
      };
      this.btnAvancar = {
        text: "Escolher plano",
        disabled: false,
      };
      return returnReq();
    },
  },
  created() {
    console.log(this.client.state)
    if (this.city) {
      this.model_city = this.city;
    }
    if (this.state) {
      this.model_state = this.state;
    }
    for (var city of brazil.estados) {
      this.select_state.push({
        value: city.sigla,
        label: city.nome,
      });
    }
  }
};
</script>
